module.exports = __webpack_public_path__ + "img/US_StoneGatherRate_ua.d6e540ce.webp";